var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-25"},[_c('router-view'),(_vm.comingSoonModalVisible)?_c('coming-soon-modal',{attrs:{"visible":_vm.comingSoonModalVisible},on:{"modal-close":function($event){_vm.comingSoonModalVisible = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }